import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { isEmpty } from 'lodash';
import { Observable } from 'rxjs';
import { FeatureFlag } from '../../data/models';
import { FeatureFlagService } from './feature-flag.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagGuard {
  constructor(
    private readonly featureFlagService: FeatureFlagService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const feature: FeatureFlag = route.data.feature;

    if (isEmpty(feature) || !this.featureFlagService.isAllowed(feature)) {
      this.router.navigate(['/']);
      return false;
    }

    return true;
  }
}
